import ConsultationsUserArchive from 'features/consultations/consultationsUserArchive';
import { useTitle } from '../helpers';

/**
 * @page Consultation user archive page
 */
const ConsultationUserArchivePage = () => {
  useTitle('Информация о консультации в архиве');

  return (
    <div>
      <h3>Страница информации о консультации в архиве</h3>
      <ConsultationsUserArchive />
    </div>
  );
};

export default ConsultationUserArchivePage;
